"use client"

import type { ReactNode } from "react"
import type { Locale } from "@/lib/content"
import { LocaleProvider } from "@/lib/locale-context"
import { ThemeProvider } from "@/lib/theme-context"
import { SmoothScroll } from "@/lib/smooth-scroll"

export function Providers({ locale, children }: { locale: Locale; children: ReactNode }) {
  return (
    <ThemeProvider>
      <LocaleProvider locale={locale}>
        <SmoothScroll>{children}</SmoothScroll>
      </LocaleProvider>
    </ThemeProvider>
  )
}
